module.exports = __webpack_public_path__ + "static/media/suraksha.fd453419.svg";